let loadingRequests = 0
let loadingTimer = 0
let lastHideTime = 0
const minHideShowDistance = 800 // if time between hide and show is less than this variable loading not show

function showLoading (hideBackground = false) {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    let showLoadingTime = Date.now()
    if (showLoadingTime - lastHideTime > minHideShowDistance) {
      if (hideBackground) {
        loadingRequests = 0
      }
      loadingRequests = loadingRequests + 1
      clearTimeout(loadingTimer)

      appLoading.classList.remove('in-active')
      appLoading.style.display = 'block'

      if (hideBackground) {
        appLoading.classList.add('hide-background')
      }

      setTimeout(() => {
          appLoading.classList.add('active')
      }, 10)
    }
  }
}

function hideLoading (force = false) {
  if (loadingRequests > 0) {
    loadingRequests = loadingRequests - 1
  }
  clearTimeout(loadingTimer)
  loadingTimer = setTimeout(() => {
    if (loadingRequests <= 0 || force) {
      const appLoading = document.getElementById('loading-bg')
      if (appLoading) {
        appLoading.classList.remove('active')
        appLoading.classList.remove('hide-background')
        appLoading.classList.add('in-active')

        setTimeout(() => {
          lastHideTime = Date.now()
          appLoading.style.display = 'none'
        }, 10)
      }
    }
  }, 300)
}

export const loading = {
  show: showLoading,
  hide: hideLoading
}
